import { IMilestoneTemplate } from "@/interfaces";

export const setUniqueDefaultFor = (
  updatedMilestoneId: string,
  milestoneTemplates: IMilestoneTemplate[]
): IMilestoneTemplate[] => {
  const updatedMilestone = milestoneTemplates.find(
    ({ id }) => id === updatedMilestoneId
  );

  if (!updatedMilestone) return milestoneTemplates;

  return milestoneTemplates.map((milestoneTemplate) => {
    const { targetDatesRequired, id } = milestoneTemplate;

    const isNotUpdatedMilestone = id !== updatedMilestoneId;
    const hasDefaultForValues = !!milestoneTemplate.defaultFor?.length;

    const shouldUpdate =
      targetDatesRequired && isNotUpdatedMilestone && hasDefaultForValues;

    let defaultFor = milestoneTemplate.defaultFor;

    if (shouldUpdate) {
      defaultFor = defaultFor?.filter(
        (defaultCategory) =>
          !updatedMilestone.defaultFor?.includes(defaultCategory)
      );
    }

    return {
      ...milestoneTemplate,
      defaultFor,
    };
  });
};
